import { isApiError } from "@profitlens/api-client";
import type { TFunction } from "i18next";

/**
 * Resolve any thrown value to a localised message:
 * `errors.<code>` first, then the server message, then the generic fallback.
 */
export function translateError(error: unknown, t: TFunction): string {
  if (isApiError(error)) {
    const key = `errors.${error.code}`;
    const translated = t(key);
    if (translated !== key) return translated;
    return error.message || t("errors.unknown");
  }
  if (error instanceof Error && error.message) return error.message;
  return t("errors.unknown");
}
